import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export function RecipeRedirect() {
  const navigate = useNavigate()
  useEffect(() => {
    navigate('/discover', { replace: true })
  }, [navigate])
  return null
}

